import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4726D1"
    },
    secondary: {
      main: "#EDC3F3"
    }
  },

  typography: {
    button: {
      textTransform: "none",
      minHeight: "auto",
      minWidth: "auto"
    },
    fontFamily: [
      "TWK Lausanne",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(",")
  }
});

export default theme;
